module.exports = __webpack_public_path__ + "img/scene4.33e4fb96.png";